export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/directives/nav-dropdown/index.ts